import { render, staticRenderFns } from "./SeatDemo.vue?vue&type=template&id=354db483&"
import script from "./SeatDemo.vue?vue&type=script&lang=js&"
export * from "./SeatDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports